import React, {
  useRef,
  Dispatch,
  SetStateAction,
  useLayoutEffect,
} from "react";
import { Textarea } from "../../../../../Input/Textarea";
import { ModalSection } from "../../../../Party/PartyDetail/PartyExitModal/PartyExitModal";
import { ModalLabel } from "../../../../Users/UserDetail/CommentModal/TargetContainer";

interface PopupContentSectionProps {
  modalType?: string;
  desc: string;
  setDesc: Dispatch<SetStateAction<string>>;
}

export default function PopupContentSection({
  modalType,
  desc,
  setDesc,
}: PopupContentSectionProps) {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useLayoutEffect(() => {
    if (textareaRef && textareaRef.current) {
      textareaRef.current.style.height = "0px";
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + "px";
    }
  }, [desc]);

  return (
    <ModalSection>
      <ModalLabel>본문 입력</ModalLabel>

      <Textarea
        ref={textareaRef}
        placeholder="직접 입력"
        value={desc}
        onChange={(e) => setDesc(e.target.value)}
        style={{ minHeight: 59, maxHeight: 290 }}
        readOnly={modalType === "view"}
      />
    </ModalSection>
  );
}
